import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SCSS_COLORS } from '../../../../../colors';

@Component({
  selector: 'lp2-private-class-state-signed-up',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [
    `
      .container {
        padding: 30px;
      }
      .state-text {
        max-width: 300px;
      }
    `,
  ],
  template: `
    <lp2-private-class-banner-container>
      <lp2-private-class-center-header-banner>
        <div class="container d-flex flex-1 flex-column justify-content-between align-items-center my-3">
          <lp2-animated-circle-icon
            [backgroundColor]="colors['$white']"
            [color]="colors['$orange']"
            [rippleColor]="colors['$private-class-light-blue']"
            width="72"
            height="72"
          >
            <i class="fa fa-user"></i>
          </lp2-animated-circle-icon>
          <p class="m-0 fs-5 lh-4 fw-bold text-center state-text">{{ stateTextKey | translate }}</p>
        </div>
      </lp2-private-class-center-header-banner>
    </lp2-private-class-banner-container>
  `,
})
export class PrivateClassStateSignedUpComponent {
  @Input() stateTextKey: string;
  public colors = SCSS_COLORS;
}



// WEBPACK FOOTER //
// ./ts/app/home/live-class-revamp/private-class-banner/private-class-states/private-class-state-signed-up.component.ts